import { IntersectionObserver } from 'foundations-components/transitional/components/IntersectionObserver';
import { jsx as _jsx } from "react/jsx-runtime";
const withIntersectionObserver = (WrappedComponent, intersectionObserverProps) => {
  return props => {
    return /*#__PURE__*/_jsx(IntersectionObserver, Object.assign({
      renderContent: isIntersecting => {
        if (isIntersecting) {
          return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
        }
        return /*#__PURE__*/_jsx("div", {}); // Placeholder element to observe
      },
      onIntersectionChange: ({
        entries,
        observer
      }) => {
        if (entries[0].isIntersecting) {
          // Since we don't want to un-render, we can disconnect
          observer.disconnect();
        }
      }
    }, intersectionObserverProps));
  };
};
export default withIntersectionObserver;